// Real Ménage KGD footage — locally optimized MP4 (H.264 720p, muted, faststart)
// Sources are stored under /public/videos/ so they are served by the same origin as the app.
// If the client wants to swap a clip, replace the file and keep the same filename.

export const VIDEOS = {
    // Hero — clean bathroom + shiny faucet (IMG_0168, 12s loop, ~730KB).
    hero:     { src: "/videos/hero.mp4",     poster: "/images/hero-poster.jpg" },
    // Le Standard KGD — subtle detail from IMG_4841 (~400KB).
    standard: { src: "/videos/standard.mp4", poster: "" },
    // Collection Émeraude — IMG_0163 (14s, ~970KB).
    emeraude: { src: "/videos/emeraude.mp4", poster: "" },
    // Collection Rubis — no video (typography-forward section instead).
    rubis:    { src: "",                     poster: "" },
    // Collection Saphir — no video (sober static premium image).
    saphir:   { src: "",                     poster: "" },
};

export const hasVideo = (key) => !!(VIDEOS[key] && VIDEOS[key].src);
